<!-- <app-sub-title [titleText]="'Notifications Settings'" [textAlign]="'left'"></app-sub-title> -->
<div class="sm:px-4 mx:px-8">
  <div class="result-table">
    <div class="desc">{{'NOTIFICATION_TIPS' | translate}}</div>
    <nz-table
        [nzFrontPagination]="false"
        #fixedTable [nzScroll]="{ x: 'auto' }"
        [nzData]="notificationData">
            <thead>
            <tr>
                <th nzWidth="200px">{{'NOTIFICATION_TYPE' | translate}}</th>
                <th nzWidth="300px">{{'NOTIFICATION_NAME' | translate}}</th>
                <th nzWidth="300px">{{'DISPLAY_IN-ESHOP' | translate}}</th>
                <th nzWidth="300px">{{'SEND_VIA_EMAIL' | translate}}</th>
                <th nzWidth="300px">{{'SEND_VIA_MOBILE_MESSAGE' | translate}}</th>
            </tr>
            </thead>
            <tbody>
                    <!-- <ng-container> [attr.rowspan]="3" -->
                      <ng-container *ngFor="let notification of notificationData">
                        <tr >
                          <td  *ngIf="isFirstChannel(notification.bizType,notification)" [attr.rowspan]="getRowSpanByBizType(notification.bizType)" class="td-line"><custom-tag [content]="notification.bizType" [backgroundColor]="
                            notification.bizType=='Achivement'?'#F1F8F7':notification.bizType=='Order'?'#E5F2F9':'#F9F2F9'" [fontColor]="notification.bizType=='Achivement'?'#18837E':notification.bizType=='Order'?'#007BC0':'#9E2896'" [borderColor]="notification.bizType=='Achivement'?'#18837E':notification.bizType=='Order'?'#007BC0':'#9E2896'"></custom-tag>
                          </td>
                          <td>{{notification.name}}</td>
                          <td ><nz-switch *ngIf="includeChannel(notification,'IN-SITE')" [ngModel]="isChannelActive(notification, 'IN-SITE')"
                            (ngModelChange)="toggleChannel(notification, 'IN-SITE', $event)"></nz-switch></td>
                          <td><nz-switch *ngIf="includeChannel(notification,'EMAIL')" [ngModel]="isChannelActive(notification, 'EMAIL')"
                            (ngModelChange)="toggleChannel(notification, 'EMAIL', $event)"></nz-switch></td>
                          <td><nz-switch *ngIf="includeChannel(notification,'MSN')" [ngModel]="isChannelActive(notification, 'MSN')"
                            (ngModelChange)="toggleChannel(notification, 'MSN', $event)"></nz-switch></td>
                        </tr>
                      </ng-container>
            </tbody>
    </nz-table>
</div>
</div>



